export enum TabNames {
  Episodes = "Episodes",
  Info = "Info",
  Music = "Music",
  Comment = "Comment",
  Recordings = "Recordings",
}
